import { Tile } from "@2u-landing-pages/components";
import { Container } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";
import { TileGroup, TilesProps } from "./Bento.types";
// @ts-ignore
import styles from "./Tiles.module.scss";

export const Tiles: React.FC<TilesProps> = ({
  variation,
  embedded,
  groups,
  tile_background_color,
  phoneNumber,
  parseMetadata,
}) => {
  const isExtended = variation === "extended";
  const isInline = variation === "inline";

  return (
    <Container
      flex
      direction="column"
      wrap={embedded && groups?.length >= 2 ? "wrap" : "nowrap"}
      lg={{ direction: "row" }}
      className={styles.tileContainer}
    >
      {groups.map(
        (group: TileGroup, index: number) =>
          Boolean(group?.length) && (
            <Container
              flex
              key={index}
              className={cn(styles.group, {
                [styles.groupEmbedded]: !isExtended && embedded && (group || []).length > 1,
                [styles.groupEmbeddedExtended]: isExtended && embedded && groups?.length > 1,
                [styles.groupFullWidth]: embedded && index === 2 && (group || []).length > 1,
              })}
            >
              {group?.map((item, idx: number) => (
                <Tile
                  padded={Boolean(tile_background_color)}
                  key={idx}
                  className={styles.tile}
                  content={item}
                  desktopOrientation="vertical"
                  mobileOrientation="vertical"
                  textAlign={isInline ? "left" : undefined}
                  heading={isInline ? { variant: "heading-lg" } : undefined}
                  subhead={isInline ? { variant: "subhead-sm" } : undefined}
                  phoneNumber={phoneNumber}
                  parseMetadata={parseMetadata}
                />
              ))}
            </Container>
          )
      )}
    </Container>
  );
};
